export default "__VITE_ASSET__5718c76d__"